import { useTranslation } from 'react-i18next'
import SubjectGroup from '../SubjectGroup/SubjectGroup'
import styles from './SemesterCard.module.scss'

const SemesterCard = ({
  sem,
  open,
  toggleOpen,
  stats,
  progressByTheme,
  assignmentsByTheme,
  setStatus,
}) => {
  const { t } = useTranslation('common')
  return (
    <div className={`unv-card ${styles.semester}`}>
      <div className={styles.semesterHeader} onClick={toggleOpen}>
        <div className={styles.semTitle}>
          {sem.name || t('syllabus.semester_simple', { n: sem.number || sem.id })}
        </div>
        <div className={styles.semProgress}>
          <div className={styles.progressBar}>
            <div className={styles.progressFill} style={{ width: `${stats.percent}%` }} />
          </div>
          <span className={styles.muted}>
            {stats.done} / {stats.total}
          </span>
        </div>
        <span className="unv-btn unv-btn--ghost">{open ? '▼' : '▶'}</span>
      </div>

      {open && (
        <div className={styles.subjects}>
          {(sem.subjects || []).map((sub) => (
            <SubjectGroup
              key={sub.id}
              sub={sub}
              progressByTheme={progressByTheme}
              assignmentsByTheme={assignmentsByTheme}
              setStatus={setStatus}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default SemesterCard
